import * as React from 'react';

function TermsAndConditionsIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 17 16" fill="none" {...props}>
			<g clipPath="url(#prefix__clip0_27401_211612)" fill="currentColor">
				<path d="M9.655 12.815c0-1.084.423-2.104 1.19-2.87a4.033 4.033 0 012.87-1.19c.89 0 1.737.285 2.436.811.04-.566.063-1.2.064-1.909-.002-1.783-.151-3.089-.311-4.049-.28-1.58-1.716-3.017-3.297-3.296-.96-.16-2.266-.31-4.05-.312-1.783.002-3.09.152-4.049.311-1.58.28-3.017 1.716-3.296 3.297-.16.96-.31 2.266-.312 4.05.003 1.783.152 3.089.312 4.049.279 1.58 1.715 3.017 3.297 3.296.96.16 2.265.31 4.049.312.709-.001 1.342-.025 1.909-.064a4.03 4.03 0 01-.812-2.436zm-4.88-9.114h7.566a.886.886 0 010 1.772H4.774a.886.886 0 010-1.772zm0 5.473a.886.886 0 010-1.772h4.441a.886.886 0 010 1.772H4.774z" />
				<path d="M13.715 9.633a3.185 3.185 0 100 6.37 3.185 3.185 0 000-6.37zm.594 4.765a.594.594 0 01-1.188 0v-1.566a.594.594 0 011.188 0v1.566zm-.024-2.837a.335.335 0 01-.258.258 1.929 1.929 0 01-.318.024 1.9 1.9 0 01-.317-.024.335.335 0 01-.258-.258 1.94 1.94 0 01-.024-.318c0-.14.011-.241.024-.317a.335.335 0 01.258-.258c.075-.012.178-.024.317-.024.14 0 .242.012.318.024a.335.335 0 01.258.258c.012.075.024.178.024.317 0 .14-.012.242-.024.318z" />
			</g>
			<defs>
				<clipPath id="prefix__clip0_27401_211612">
					<path
						fill="currentColor"
						transform="translate(.9)"
						d="M0 0h16v16H0z"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

const MemoTermsAndConditionsIcon = React.memo(TermsAndConditionsIcon);
export default MemoTermsAndConditionsIcon;
